import { create } from 'zustand';
import type { AccountView } from '../types/api';
import { setAccessToken, setOnUnauthorized } from '../api/client';

interface AuthState {
  /** Current account view from /auth/me */
  account: AccountView | null;
  /** Whether the auth state is still loading (initial /auth/me call pending) */
  isLoading: boolean;
  /** Whether the user is authenticated */
  isAuthenticated: boolean;

  setAccount: (account: AccountView | null) => void;
  login: (account: AccountView, accessToken: string) => void;
  logout: () => void;
  setIsLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => {
  // Register the unauthorized handler to auto-logout
  setOnUnauthorized(() => {
    set({ account: null, isAuthenticated: false });
    setAccessToken(null);
  });

  return {
    account: null,
    isLoading: true,
    isAuthenticated: false,

    setAccount: (account) =>
      set({
        account,
        isAuthenticated: account !== null,
        isLoading: false,
      }),

    login: (account, token) => {
      setAccessToken(token);
      set({
        account,
        isAuthenticated: true,
        isLoading: false,
      });
    },

    logout: () => {
      setAccessToken(null);
      set({
        account: null,
        isAuthenticated: false,
        isLoading: false,
      });
    },

    setIsLoading: (isLoading) => set({ isLoading }),
  };
});
